import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { RelatedJobBus } from '@app/cp/shared/models/RelatedJobBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';

@Component({
    selector: 'contract-mfg-warranty-jobs',
    templateUrl: './contract-mfg-warranty-jobs.component.html',
    styleUrls: ['./contract-mfg-warranty-jobs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContractMfgWarrantyJobsComponent extends BaseGridUIComponent<RelatedJobBus, null, ConstructionService> {

    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;

        this.aggregates = [
            { field: 'totalLaborCosts', aggregate: 'sum' },
            { field: 'invTotal', aggregate: 'sum' },
        ];
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
    }
}
